import { buildHeaders, buildRequest, buildUrl, fetchRequest } from '../utils/apis/RestApi';

export const logout = async () => {
  const url = buildUrl('ICARE_BACK', 'auth/end-session');
  const headers = buildHeaders();
  const request = buildRequest(url, 'DELETE', headers);

  await fetchRequest(request);

  globalThis.location.reload();
};
